export const GRAPHQL_ERROR_CODES = {
  BAD_USER_INPUT: 'BAD_USER_INPUT',
  UNAUTHENTICATED: 'UNAUTHENTICATED',
  FORBIDDEN: 'FORBIDDEN',
  NOT_FOUND: 'NOT_FOUND',
  INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
} as const

export type GraphQLErrorCode =
  typeof GRAPHQL_ERROR_CODES[keyof typeof GRAPHQL_ERROR_CODES]
